<template>
	<div>
		<svg width="44px" height="44px" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<g id="Jobs" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g>
					<rect id="bg-tabbar-icon" x="0" y="0" width="44" height="44"></rect>
					<g id="Combined-Shape" transform="translate(1.76, 3.52)" :fill="color" fill-rule="nonzero">
						<path d="M38.7047389,24.464 L38.7047389,34.704736 C38.7047389,35.981792 37.7190155,36.96 36.4305797,36.96 L36.4305797,36.96 L4.16784211,36.96 C2.87940632,36.96 1.7754386,35.981792 1.7754386,34.704736 L1.7754386,34.704736 L1.7754386,24.464 L38.7047389,24.464 Z M25.7419066,0 C27.9679516,0 29.6498245,1.808576 29.6498245,4.015264 L29.6498245,4.015264 L29.6498245,7.216 L38.3056203,7.216 C39.5370645,7.216 40.48,8.27376 40.48,9.573872 L40.48,9.573872 L40.48,19.358416 C40.48,20.642336 39.5581923,21.648 38.3056203,21.648 L38.3056203,21.648 L32.6680702,21.648 L32.6680702,15.312 L28.4070176,15.312 L28.4070176,21.648 L11.8954386,21.648 L11.8954386,15.312 L7.63438597,15.312 L7.63438597,21.6436 L2.32298385,21.648 C1.04182737,21.648 0,20.620864 0,19.358416 L0,19.358416 L0,9.573872 C0,8.295936 1.12260982,7.216 2.38157334,7.216 L2.38157334,7.216 L10.8301754,7.216 L10.8301754,4.015264 C10.8301754,1.808576 12.6302926,0 14.8563375,0 L14.8563375,0 L25.7419066,0 Z M25.2112281,4.576 L15.2687719,4.576 L15.2687719,7.216 L25.2112281,7.216 L25.2112281,4.576 Z" id="path-1"></path>
					</g>
				</g>
			</g>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgBank',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
	},
};
</script>

<style scoped>

</style>